import { Observable } from 'rxjs';
import 'reflect-metadata';
import { IJob, IJobParamsCreate, IJobParamsUpdate, IJobSearchPayload, IJobSearchResults } from './job.interface';

/**
 * @route `job`
 */
export interface IJobController {
  // private logger = new Logger(CommercialAutoRateFactorsController.name);

  /**
   * POST
   * @route 'search'
   * @param params
   *
   * @AccountRoles([EUserAccountTypes.ADMIN, EUserAccountTypes.CLIENT, EUserAccountTypes.CARRIER, EUserAccountTypes.REINSURER], ['super_admin'])
   */
  search(params: IJobSearchPayload): Promise<IJobSearchResults> | Observable<IJobSearchResults>;

  /**
   *
   * @param id This is the _id of the rate factor to get a single item
   *
   * @security Account types [ADMIN,INSURED]
   * @roles ['super_admin]
   */
  getById(id: string): Promise<IJob | null> | Observable<IJob | null>;

  /**
   *
   * @param params
   *
   * @security Account types [ADMIN,INSURED]
   * @roles ['super_admin]
   */
  create(params: IJobParamsCreate): Promise<IJob> | Observable<IJob>;
  /**
   *
   * @param params
   *
   * @security Account types [ADMIN,INSURED]
   * @roles ['super_admin]
   */
  update(params: IJobParamsUpdate): Promise<IJob> | Observable<IJob>;
  /**
   *
   * @param params
   *
   * @security Account types [ADMIN,INSURED]
   * @roles ['super_admin]
   */
  delete(id: string): Promise<IJob> | Observable<IJob>;
}
